import { useWindowScroll } from "@mantine/hooks";
import NavbarLinks from "./NavLinks";
import { useState } from "react";


function Navbar({ isMobile, onLinkClick }) {
  const [scroll, scrollTo] = useWindowScroll();
  const [activeLabel, setActiveLabel] = useState(null);

  function getOffset(id) {
    return document.getElementById(id)?.offsetTop || 0;
  }

  function scrollToHome() {
    const aboutUs = getOffset('home');
    scrollTo({ y: aboutUs - 150 });
  }

  function scrollToAboutUs() {
    const aboutUs = getOffset('aboutUs');
    scrollTo({ y: aboutUs - 170 });
    setActiveLabel('About Us');
  }

  function scrollToRemittance() {
    const remittance = getOffset('chooseRemit');
    scrollTo({ y: remittance - 160 });
    setActiveLabel('Our Services');
  }

  function scrollToOtherServices() {
    const otherServices = getOffset('otherServices');
    scrollTo({ y: otherServices - 180 });
    setActiveLabel('Our Misson');
  }

  function scrollToCustomerTestimonials() {
    const customerTestimonials = getOffset('contactUs');
    scrollTo({ y: customerTestimonials + 250 });
    setActiveLabel('Contact Us');
  }

  return (
    <NavbarLinks
      activeLabel={activeLabel}
      onLinkClick={onLinkClick}
      links={[
        {
          label: (
            <img
              src="/img/gcgcIcon.png"
              alt="Home"
              style={{ width: '120px', height: 'auto', cursor: 'pointer' }}
            />
          ),
          onClick: scrollToHome, // ⬅️ Clickable image scrolls to About Us
        },
        {
          label: 'About Us',
          onClick: scrollToAboutUs,
        },
        {
          label: 'Our Services',
          onClick: scrollToRemittance,
        },
        {
          label: 'Our Misson',
          onClick: scrollToOtherServices,
        },
        {
          label: 'CONTACT US',
          onClick: scrollToCustomerTestimonials,
        },
      ]}
    />
  );
}

export default Navbar;
